import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface CancelVDRFileRemovalRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const CancelVDRFileRemoval = createAsyncThunk(
    'dataRoom/cancelFileRemoval',
    async (
        { engagementId, fileId, fileSourceType }: CancelVDRFileRemovalRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/cancel-removal?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not cancel file removal at the moment.',
                    'error'
                );
                throw new Error('Failed to cancel file removal');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while cancelling file removal.',
                'error'
            );
            throw error;
        }
    }
);

